import { ref } from '@vue/composition-api'
import draftApi from '@/services/api/drafts'
import eventApi from '@/services/api/events'
import EventBus from '@/store/EventBus'

export default function useDraftEvents({ onError, onSuccess } = {}) {
  const events = ref([])
  const loading = ref(false)
  const deleting = ref(false)
  const currentDraftId = ref(null)

  function emitError(msg) {
    if (onError) onError(msg)
    else EventBus.$emit('http-error', msg)
  }

  function emitSuccess(msg) {
    if (onSuccess) onSuccess(msg)
    else EventBus.$emit('show-success', msg)
  }

  async function loadEvents(draftId) {
    currentDraftId.value = draftId
    loading.value = true
    try {
      const res = await draftApi.events(draftId)
      events.value = res.data.data
    } catch (err) {
      const data = err.response != null ? err.response.data : null
      const msg = data != null && data.message != null ? data.message : 'Failed to load events.'
      emitError(msg)
    } finally {
      loading.value = false
    }
  }

  async function reorderEvents(orderedIds, draftId) {
    const id = draftId != null ? draftId : currentDraftId.value
    try {
      const res = await eventApi.reorder(id, orderedIds)
      const msg = res.data != null && res.data.message != null ? res.data.message : 'Events order has been saved.'
      emitSuccess(msg)
      return true
    } catch (err) {
      const data = err.response != null ? err.response.data : null
      const msg = data != null && data.message != null ? data.message : 'Failed to save order.'
      emitError(msg)
      if (currentDraftId.value != null) await loadEvents(currentDraftId.value)
      return false
    }
  }

  async function deleteEvent(eventId) {
    deleting.value = true
    try {
      const res = await eventApi.destroy(eventId)
      const msg = res.data != null && res.data.message != null ? res.data.message : 'The event has been deleted.'
      await loadEvents(currentDraftId.value)
      emitSuccess(msg)
    } catch (err) {
      const data = err.response != null ? err.response.data : null
      const msg = data != null && data.message != null ? data.message : 'Failed to delete event.'
      emitError(msg)
    } finally {
      deleting.value = false
    }
  }

  return { events, loading, deleting, loadEvents, deleteEvent, reorderEvents }
}



// WEBPACK FOOTER //
// ./src/composables/drafts/useDraftEvents.js